import React, {useEffect, useState} from 'react';
import {Jumbotron} from "../../core-ui/jumbotron/jumbotron";
import {Link} from "react-router-dom";
import {
    CalenderItem,
    DaysRouteIcon,
    InfoDesc,
    InfoTitle,
    MapWrapper,
    ShiftTimeContainer, ShiftTimesSummary
} from "./request-single.styles";
import {fetchData, responsiveDay, separatePriceFormat} from "../../helpers/general-function";
import {useParams} from 'react-router-dom';
import Num2persian from "num2persian";
import moment from 'moment-jalaali';
import {MapContainer, TileLayer, Marker, Popup, useMap} from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import iconPerson from "../../core-ui/map/map-icon";
import {Modal} from 'react-responsive-modal';
import {ShiftModalContainer} from "../Requests/requests.styles";
import Alert from "../../core-ui/alerts/alert";

const DAYS_MUST_SHOWS = [-3, -2, -1, 0, 1, 2, 3];

const ChangeView = ({center, zoom}) => {
    const map = useMap();
    map.setView(center, zoom);
    return null;
}

const RequestSingle = () => {

    const {shift_id} = useParams();

    const [shiftData, setShiftData] = useState(null);
    const [successModal, setSuccessModal] = useState(false);

    useEffect(() => {
        (async () => {
            const data = await fetchData(`shifts/info/${shift_id}`, 'get', {}, true);

            if (data) {
                setShiftData(data);
            }
        })()
    }, []);

    const requestToShift = async (type, shiftTimeId) => {
        const data = await fetchData(`shifts/request/${shiftTimeId}`, 'get', {method: type, warning_applied: 0}, true);

        if (data) {
            const currentShiftTimes = [...shiftData.shift_times];

            let requestedShiftTime = currentShiftTimes.find(item => item.id === shiftTimeId);
            requestedShiftTime = {
                ...requestedShiftTime,
                user_has_requested: type === 'cancel' ? 0 : 1
            };

            const newShiftTimes = shiftData.shift_times.map(item => {
                if (item.id === shiftTimeId) {
                    return requestedShiftTime;
                } else {
                    return item;
                }
            })

            setShiftData(prevState => ({
                ...prevState,
                shift_times: newShiftTimes
            }));

            setSuccessModal(true);
        }
    }

    return (
        <div className='container mt-4 mb-c-5'>
            <div className='rtl d-flex flex-column flex-lg-row align-items-lg-center'>
                <Link to='/requests' className='c-btn-gray c-rounded-3 ms-c-2 d-none d-lg-block'>بازگشت به صفحه قبل</Link>
                <p className='ms-c-2 d-lg-none text-end'>دسترسی سریع:</p>
                <ul className='p-0 m-0 d-flex flex-wrap align-items-end align-items-lg-center l-s-t-none'>
                    <li className='mb-2 mb-lg-0 ms-4 mx-lg-4'><Link to='#pharmacy-info' className='success-color'>اطلاعات
                        داروخانه</Link></li>
                    {
                        shiftData?.shift_times.map((_, index) => (
                            <li className='mb-2 mb-lg-0 ms-4 mx-lg-4' key={index}>
                                <a href={`#shift-${index+1}`} className='success-color'>شیفت اول</a>
                            </li>
                        ))
                    }
                </ul>
            </div>
            <Jumbotron className='rtl mt-4 px-lg-c-5'>
                <div className='row align-items-center'>
                    <div className='col-12 col-lg-2 text-center mb-4 mb-lg-0' id='pharmacy-info'>
                        <InfoTitle>
                            <p>اطلاعات داروخانه</p>
                        </InfoTitle>
                    </div>
                    <div className='col-12 col-lg-10'>
                        <div>
                            <InfoDesc>
                                <p>
                                    <i className='icon-building ms-2'/>
                                    {shiftData?.shift.pharmacy.address}
                                </p>
                                <p>
                                    <i className='icon-hospital ms-2'/>
                                    {shiftData?.shift.pharmacy.name}
                                    <span className='gray-color me-3'>( {shiftData?.shift.pharmacy.address} )</span>
                                </p>
                            </InfoDesc>
                        </div>
                    </div>
                </div>
                <div className='row align-items-center mt-5 mt-lg-4'>
                    <div className='col-12 col-lg-2 text-center mb-4 mb-lg-0'>
                        <InfoTitle>
                            <p>محل دقیق داروخانه</p>
                        </InfoTitle>
                    </div>
                    <div className='col-12 col-lg-10'>
                        <MapWrapper>
                            <MapContainer
                                center={shiftData && shiftData.shift.pharmacy.lat ? [shiftData.shift.pharmacy.lat, shiftData?.shift.pharmacy.lng] : [51.505, -0.09]}
                                zoom={13} className='h-100'>
                                <ChangeView
                                    center={shiftData && shiftData.shift.pharmacy.lat ? [shiftData.shift.pharmacy.lat, shiftData?.shift.pharmacy.lng] : [51.505, -0.09]}
                                    zoom={14}/>
                                <TileLayer
                                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                />
                                <Marker icon={iconPerson}
                                        position={shiftData && shiftData.shift.pharmacy.lat ? [shiftData.shift.pharmacy.lat, shiftData.shift.pharmacy.lng] : [51.505, -0.09]}>
                                    {
                                        shiftData && shiftData.shift.pharmacy.lat &&
                                        <Popup>
                                            {shiftData.shift.pharmacy.name}
                                        </Popup>
                                    }

                                </Marker>
                            </MapContainer>
                        </MapWrapper>
                    </div>
                </div>
                <div className='d-none d-lg-flex row align-items-center mt-5 mt-lg-4'>
                    <div className='col-12 col-lg-2 text-center mb-4 mb-lg-0'>
                        <InfoTitle>
                            <p>
                                توضیحات
                            </p>
                        </InfoTitle>
                    </div>
                    <div className='col-12 col-lg-10'>
                        <div>
                            <InfoDesc>
                                <p>
                                    <i className='icon-message-text ms-2'/>
                                    {shiftData?.shift.description}
                                </p>
                            </InfoDesc>
                        </div>
                    </div>
                </div>
            </Jumbotron>

            {
                shiftData?.shift_times.map((item, index) => (
                    <Jumbotron className='mt-8 mt-lg-c-4 px-lg-c-5' key={item.id} id={`shift-${index+1}`}>
                        <ShiftTimesSummary className='d-flex align-items-lg-center justify-content-between'>
                            <div className='d-flex flex-column flex-lg-row'>
                                <h5 className='success-color fw-normal'>
                                    شیفت {Num2persian(index + 1) === 'یک' ? 'اول' : Num2persian(index + 1).replace('سه', 'سو') + 'م'} - {moment(item.to).diff(item.from, 'hour')} ساعت
                                </h5>
                                {
                                    moment(shiftData.now).isAfter(moment(item.from)) ?
                                        <span className='danger-color d-inline-block me-lg-5'>شیفت منقضی شده</span>
                                        :
                                        <span className='danger-color me-lg-5'>
                                            {`${moment(item.from).diff(shiftData.now, 'day')} روز و ${moment(item.from, 'YYYY-MM-DD HH:mm:ss').subtract(shiftData.now.split(' ')[1]).format('HH:mm')} `}مانده تا آغاز شیفت
                                        </span>
                                }
                            </div>
                            {
                                item.shift_requests_count === 0 ?
                                    <h6 className='success-color'>اولین نفری باشید که اعلام آمادگی میکند</h6>
                                    :
                                    <h6 className='success-color'>{item.shift_requests_count} نفر اعلام آمادگی کرده
                                        اند</h6>
                            }
                        </ShiftTimesSummary>

                        <div className='row align-items-center mt-5 mt-lg-4'>
                            <div className='col-12 col-lg-2 text-center mb-4 mb-lg-0'>
                                <InfoTitle>
                                    <p>تقویم</p>
                                </InfoTitle>
                            </div>
                            <div className='col-12 col-lg-10'>
                                <div className='d-flex align-items-center justify-content-between justify-content-lg-center'>
                                    {
                                        DAYS_MUST_SHOWS.map((day, dayIndex) => {
                                            let currentExactDay = moment(item.from, 'YYYY-MM-DD HH:mm:ss').add(day, 'day');
                                            let currentDay = moment(item.from, 'YYYY-MM-DD').add(day, 'day');
                                            return <CalenderItem key={dayIndex}
                                                                 className={
                                                                     (moment(item.to).isAfter(currentDay) && moment(item.from).isBefore(currentDay)) || moment(item.from).isSame(currentExactDay) ? 'active-date' : ''}>
                                                <p>{responsiveDay(currentExactDay.format('dddd'))}</p>
                                                <p>{currentExactDay.format('jD')}</p>
                                            </CalenderItem>
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                        <div className='row align-items-center mt-c-5'>
                            <div className='col-12 col-lg-2 text-center mb-4 mb-lg-0'>
                                <InfoTitle>
                                    <p>زمان شیفت</p>
                                </InfoTitle>
                            </div>
                            <div className='col-12 col-lg-10'>
                                <div className='d-flex flex-column flex-lg-row justify-content-between align-items-center'>
                                    <ShiftTimeContainer className='success-gradient ms-lg-5'>
                                        <p>{moment(item.from, 'YYYY-MM-DD HH:mm:ss').format('dddd jYYYY/jMM/jDD ساعت HH:mm')}</p>
                                    </ShiftTimeContainer>
                                    <div className='d-none d-xl-flex align-items-center flex-grow-1 position-relative'>
                                        <div className='bottom-dashed-horizontal dark-gray-dashed flex-grow-1 mx-5'/>
                                        <DaysRouteIcon>
                                            <i className='icon-arrow'/>
                                        </DaysRouteIcon>
                                    </div>

                                    <p className='d-block d-xl-none my-2'>تا</p>

                                    <ShiftTimeContainer className='warning-gradient me-lg-5'>
                                        <p>{moment(item.to, 'YYYY-MM-DD HH:mm:ss').format('dddd jYYYY/jMM/jDD ساعت HH:mm')}</p>
                                    </ShiftTimeContainer>
                                </div>
                            </div>
                        </div>
                        <div className='row align-items-center mt-c-5'>
                            <div className='col-12 col-lg-2 text-center mb-4 mb-lg-0'>
                                <InfoTitle>
                                    <p>اطلاعات پرداخت</p>
                                </InfoTitle>
                            </div>
                            <div className='col-12 col-lg-10'>
                                <div>
                                    <InfoDesc>
                                        <p>
                                            حق الزحمه شیفت: {separatePriceFormat(item.earning)}
                                            <span
                                                className='gray-color me-3'>( {Num2persian(item.earning.toString())} )</span>
                                        </p>
                                        <p> تاریخ پرداخت
                                            حق‌الزحمه: {moment(item.settlement_date, 'YYYY-MM-DD').format('dddd jYYYY/jMM/jDD')}
                                        </p>
                                    </InfoDesc>
                                </div>
                            </div>
                        </div>
                        <div className='d-lg-none row align-items-center mt-5 mt-lg-4'>
                            <div className='col-12 col-lg-2 text-center mb-4 mb-lg-0'>
                                <InfoTitle>
                                    <p>
                                        توضیحات
                                    </p>
                                </InfoTitle>
                            </div>
                            <div className='col-12 col-lg-10'>
                                <div>
                                    <InfoDesc>
                                        <p>
                                            <i className='icon-message-text ms-2'/>
                                            {shiftData?.shift.description}
                                        </p>
                                    </InfoDesc>
                                </div>
                            </div>
                        </div>
                        <div className='d-flex justify-content-center mt-c-5'>
                            {
                                item.user_has_requested === 0 ?
                                    <button className='c-btn c-btn-success px-c-2 flex-grow-1 flex-lg-grow-0 py-c-2'
                                            onClick={() => requestToShift('set', item.id)}>ارسال درخواست</button>
                                    :
                                    <button className='c-btn c-btn-outline-danger px-5 flex-grow-1 flex-lg-grow-0 py-c-2'
                                            onClick={() => requestToShift('cancel', item.id)}>لغو درخواست</button>
                            }
                        </div>
                    </Jumbotron>
                ))
            }
            <Modal open={successModal} onClose={() => setSuccessModal(false)}
                   classNames={{modal: 'c-modal-container'}}
                   showCloseIcon={false} center>
                <ShiftModalContainer className='text-center'>
                    <p className='success-color fs-c-3 text-end'>ارسال درخواست</p>
                    <Alert/>
                    <p className='success-color fs-c-2 mt-5'>درخواست شما با موفقیت ارسال شد</p>
                    <p className='gray-color fs-c-4 mt-4 rtl'>هماهنگی‌های لازم توسط داروساز مربوطه با شما انجام خواهد
                        شد.</p>
                    <button className='btn-simple-text mt-c-5' onClick={() => setSuccessModal(false)}>بازگشت به صفحه
                        قبلی
                    </button>
                </ShiftModalContainer>
            </Modal>
        </div>
    );
};

export default RequestSingle;
